import styled from "styled-components";

interface ContactData {
  client_id: number | "new";
  name?: string;
  email?: string;
  contact_type?: string;
}

interface ContactSelectBoxItemProps {
  data: ContactData;
}

const ContactSelectBoxItem = ({ data }: ContactSelectBoxItemProps) => {
  return (
    <div>
      {data.client_id === "new" ? (
        <StyledNewContact>+ Create New Contact</StyledNewContact>
      ) : (
        <>
          <StyledContactName>{data.name}</StyledContactName>
          <StyledContactInfo>
            {data.email ? data.email : ""}
            {data.email && data.contact_type ? " | " : ""}
            {data.contact_type ? data.contact_type : ""}
          </StyledContactInfo>
        </>
      )}
    </div>
  );
};

const StyledNewContact = styled.div`
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: bold;
`;

const StyledContactName = styled.div`
  margin-bottom: 5px;
`;

const StyledContactInfo = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export default ContactSelectBoxItem;
